
export const isExpired = (cardMonth, cardYear) => {
  if (!cardMonth || !cardYear) {
    return true;
  }
  const now = new Date();

  const nowMonth = now.getMonth() + 1;
  const nowYear = cardYear.length <= 2 ? now.getFullYear().toString().substring(2) : now.getFullYear();

  cardMonth = parseInt(cardMonth, 10) || 0;
  cardYear = parseInt(cardYear, 10) || 0;

  return nowYear > cardYear || (nowYear === cardYear && nowMonth > cardMonth);
};

export const anonymizeCardNumber = (str, isAdyen) => {
  if (isAdyen) {
    return '✷✷✷✷ ✷✷✷✷ ✷✷✷✷ ' + str;
  } else {
    return str.substring(0, 4).concat(' ✷✷✷✷ ✷✷✷✷ ', str.substring(str.length - 4, str.length));
  }
};

export const smallAnonymizeCardNumber = (str) =>
  '✷✷✷✷ ' + str.substring(str.length - 4, str.length);

export const handleCheckedUserCreditCards = (creditCards) => {
  if (!creditCards.some(({ isDefault }) => isDefault) || creditCards.length === 1) {
    creditCards[0] = { ...creditCards[0], checked: true };
  }
  return creditCards;
};
